<div (click)="showProductDetail()" class="main__container">
  <!--Affichage des données du produit-->
  <div swipeLeft class="card" >
    <div class="img__container">
      <img
        *ngIf="imageUrl$ | async as url; else noImagePath"
        [ngSrc]="url"
        fill
        [placeholder]="placeholder"
        alt="image du produit">

      <!-- Si pas de nom de l'image-->
      <ng-template #noImagePath>
        <img
        [src]="placeholder"
        alt="image du produit">
      </ng-template>
    </div>
    <div class="header m-2">
      <!--Description-->
      <div class="description__container">
        <!--Catégory-->
        <div>
          <p>Catégorie: <span class="uppercase text-sm font-medium">{{product.productCatgegoryLabel}}</span></p>
        </div>
        <!--Description-->
        <div class="p-1">
          <p class="text-xs">{{product.productName}}</p>
        </div>
      </div>
    </div>
    <!--Status du produit-->
    <div class="flex h-full w-1rem p-1">
      <div class="flex-1 border-round-xs {{ product.productStatuscode| statusPipe }}">

      </div>
    </div>
  </div>
 <!--Boutton désactivation d'un produit-->
 <div class="delete__button__container">
    <!-- Reactivation du produit-->
    <ng-container *ngIf="areProductInActivateMode$ | async; else notInProductInActivateMode">
      <div (click)="activateProduct($event)" class="flex border-circle mr-4 shadow-4 bg-white align-items-center justify-content-center">
        <i class="p-2 pi pi-check-circle pi-cog" style="color:rgb(63, 231, 57); font-size: 1.5rem"></i>
      </div>
    </ng-container>

    <!-- Desactivation du produit-->
    <ng-template #notInProductInActivateMode>
      <div (click)="desactivateProduct($event)" class="flex border-circle mr-4 shadow-4 bg-white align-items-center justify-content-center">
        <i class="p-2 pi pi-trash pi-cog" style="color:red; font-size: 1.5rem"></i>
      </div>
    </ng-template>
  </div>
</div>
